import fp from 'lodash/fp';
import * as modules from './modules';
import { sagaMiddleware } from './store';

const sagas = fp.flow(
  fp.map((key) => fp.get(key, modules).saga),
  fp.filter(fp.identity)
)(fp.keys(modules));

const rootSaga = {
  run: () => fp.forEach((saga) => sagaMiddleware.run(saga), sagas)
};

export default rootSaga;



// WEBPACK FOOTER //
// ./src/state/sagas.js